import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export default function AllowanceCard({
  title,
  type,
  value,
  description,
  category = "ALLOWANCE", // ALLOWANCE | DEDUCTION
  onEdit,
  onDelete,
}) {
  // dynamic border color
  const borderColor = category === "DEDUCTION" ? "#dc2626" : "#2563eb"; // red / blue

  // chip color
  const chipBg =
   category === "DEDUCTION" ?
    " rgba(239, 68, 68, 0.2)"
   :   "rgba(59, 130, 246, 0.2)" // dark blue

     const chipBorder =
   category === "DEDUCTION" ?
    '1px solid rgba(239, 68, 68, 1)'
   :   "1px solid rgba(59, 130, 246, 1)"
  return (
    <Card
      sx={{
        background: "linear-gradient(145deg, #0d1b2a, #1b263b)",
        borderRadius: 3,
        // p: 2,
        color: "#fff",
        border: `2px solid ${borderColor}`,
      }}
    >
        <Box sx={{width:'100%', height:'3px', background:borderColor}} />
      <CardContent>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontWeight="600" sx={{  color: "#fff", fontSize:16}}>
            {title}
          </Typography>

          <Chip
            label={type}
            sx={{
              bgcolor: chipBg,
              color: "#fff",
              fontWeight: 500,
              border:`1px solid ${chipBorder}`,
            //   borderColor:chipBorder
            }}
          />
        </Box>

        {/* Value */}
        <Typography variant="h6" mt={2} fontWeight="700" sx={{ color: "#fff",}}>
          {value}
        </Typography>

        {/* Description */}
        <Typography variant="body2" mt={1} color="#e0e0e0">
          {description}
        </Typography>

        {/* Buttons */}
        <Box display="flex" gap={2} mt={3}>
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={onEdit}
            sx={{
              borderColor: "#94a3b8",
              color: "#fff",
              "&:hover": { borderColor: "#fff" },
              borderRadius:'8px', textTransform:'capitalize'
            }}
          >
            Edit
          </Button>

          <Button
            variant="contained"
            startIcon={<DeleteIcon />}
            onClick={onDelete}
            sx={{
              bgcolor: "#dc2626",
              "&:hover": { bgcolor: "#b91c1c" },
              borderRadius:'8px', textTransform:'capitalize'
            }}
          >
            Delete
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
